<template>
  <div class="instagram-tile flex flex-col">
    <div class="overflow-hidden rounded">
      <VideoPictureElement
        :img="image"
        :video="video"
        :show-video-inline="true"
        class="group"
        img-class="w-full object-cover transition-transform duration-200 group-hover:scale-105"
        :breakpoints="BREAKPOINTS"
      />
    </div>
    <div class="py-4">
      <p class="text-base font-bold">
        {{ headline.text }}
      </p>
    </div>
    <p>{{ text }}</p>
  </div>
</template>

<script setup>
import VideoPictureElement from "~/templates/elements/VideoPictureElement.vue";
import SvgIcon from "~/templates/elements/SvgIcon.vue";

const BREAKPOINTS = {
  start: DIMENSIONS["start"]?.ratio["2/3"],
  md: DIMENSIONS["md"].width["2/3"],
};

import { DIMENSIONS } from "~/utils/helper/imaging";
defineProps(["video", "image", "headline", "text"]);
</script>
